import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { SoapRanapRequest, SoapRanapResponseItem } from "@/types/soap";

async function create(data: SoapRanapRequest) {
  const response = await http
    .postData("/soap-ranap-dokter", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data.data;
}

async function update(id, data: SoapRanapRequest) {
  const response = await http
    .putData(`/soap-ranap-dokter/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data.data;
}

async function getByRegister(
  register_id: string | number
): Promise<{ status: number; data: SoapRanapResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/soap-all`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http.getData(`/soap-ranap-dokter/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function destroy(id, alasan) {
  const response = await http
    .deleteDataParam(`/soap-ranap-dokter/${id}`, {
      params: {
        alasan: alasan
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function verify(id, data) {
  const response = await http
    .postData(`/soap-ranap-dokter/${id}/verifikasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

function print(reg) {
  window.open(`${http.getAPI()}/register/${reg}/cppt/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  verify,
  print
};
